import axios from "axios";
import {
    MEMBER_GET_PURCHASED_ORDERS,MEMBER_PRODUCT_CATEGPRY,MEMBER_INVOICES_BRANCH,VENDOR_GET_TERMINATED_VP_NAMES_MEMBER,
    MEMBER_GET_BH_VERIFIED_VENDOR_PARTNER_PURCHASES, MEMBER_GET_INVOICE_DATA,MEMBER_VENDOR_NAMES,
    MEMBER_GET_TERMINATED_VP_OPPORTUNITIES_DETAILS, MEMBER_GET_TERMINATED_VP_OPPORTUNITIES,
    MEMBER_GET_CARDS_DATA_FOR_MEMBER_DATA_TAB,VENDOR_OUTSIDE_PURCHASE_PRODUCT_CATEGORY_LIST, MEMBER_GET_CARDS_DATA_FOR_IMARKVERIFIED_DATA_TAB,
    VENDOR_FULL_INFO,MEMBER_PURCHASE_WITHIN_IMARK,MEMBER_FBI_ELIGIBLE_CHECK,MEMBER_FBI_REBATE,MEMBER_PURCHASE_OUTSIDE_IMARK,MEMBER_OUTSIDE_PURCHASE_BY_CATEGORY
    ,MEMBER_MONTHS_FILTER,MEMBER_VERIFIED_MONTHS_FILTER,MEMBER_CONVERSION_MONTHS_FILTER,MEMBER_QUALIFICATION,MEMBER_QUALIFICATION_STATUS,MEMBER_GET_VERIFIED_REBATE_TRENDS_GRAPH, VENDOR_GET_OPPORTUNITY_BY_MEMBER,VENDOR_GET_TVOPPORTUNITY_BY_CATEGORY,
    MEMBER_QUALIFICATION_PURCHASES,MEMBER_BRANCH,MEMBER_PURCHASE_ORDER_EXCEL,
    VENDOR_GET_OPPORTUNITY_BY_CATEGORY, VENDOR_GET_TOP_10_CATEGORIES, VENDOR_GET_TOP_10_MEMBERS_DATA,
    VENDOR_MONTHS_FILTER,VENDOR_CONVERSION_MONTHS_FILTER,VENDOR_DASHBOARD_GET_REBATES_OVERVIEW, VENDOR_DASHBOARD_GET_GROUP_GROWTH_REBATE,
    VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_GRAPH, VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_BUSINESS,
    VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_MEMBER,VENDOR_PRODUCT_CATEGORY,VENDOR_GET_TERMINATED_VP_NAMES_CORPORATE, VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_REGION,
    VENDOR_GET_DATE,CORPORATE_PRODUCT_CATEGORY,CORPORATE_OVERVIEW_OVERALL_SALES_AND_REBATE_DATA,
    CORPORATE_OVERVIEW_VENDOR_PARTNER_PERFORMANCE, CORPORATE_OVERVIEW_MEMBER_PERFORMANCE,
    CORPORATE_OPPORTUNITIES_CARDS_DATA,CORPORATE_SALES_REBATE_OPPORTUNITIES_TREND, CORPORATE_OPPORTUNITIES_UNAPP_SUPP_VOLUME_BY_MEMBER_DATA,
    CORPORATE_OPPORTUNITIES_VENDOR_PARTNER_VOLUME_DATA,MONTHS_FILTER,
    VENDOR_GET_SALES_CARD_DATA,VENDOR_PRODUCT_LIST, VENDOR_GET_TERMINATED_VP_NAMES,
    VENDOR_DASHBOARD_GET_MEMBER_PURCHASES_GRAPH,VENDOR_DASHBOARD_GET_MEMBER_LIST,
    TOKEN_ERROR,CORPORATE_TVPO_VOLUME_OPP_BY_MEMBER, CORPORATE_TVPO_CONVERSION_OPP_PO_DETAILS_DATA,
    CORPORATE_TVPO_CONVERSION_OPPORTUNITY_DATA, CORPORATE_TVPO_TOP_10_MEMBERS_DATA, CORPORATE_TVPO_VOLUME_OPP_BY_PRODUCT_GROUP_DATA,
    CORPORATE_TVPO_TOP_10_PRODUCT_GROUPS_DATA,  CORPORT_TVPO_TVPO_NAMES, SAVE_VENDOR_ID,
    SAVE_MEMBER_ID, CORPORATE_FEEDBACK_UNAPPROVED_SUPPLIER_MAPPING,
    CORPORATE_FEEDBACK_WRONG_CATEGORY, CORPORATE_FEEDBACK_PRODUCTS_NOT_SOLD,
    CORPORATE_FEEDBACK_FAVORABLE_SUPPLIER_FEEDBACK, CORPORATE_OVERVIEW_GROWTH_REBATE, STATE_REGIONS,CORPORATE_FBI_REBATE,
    MEMBER_FAVORABLE_SUPPLIER_FEEDBACK, STATE_TO_STATE_MAPPING,
    FORGOT_PASSWORD, VERIFY_TOKEN, UPDATE_PASSWORD, CHANGE_PASSWORD,CORPORATE_OVERVIEW_BASE_REBATES,CORPORATE_VENDORDATA_GROWTH_REBATE,
    CORPORATE_OPPORTUNITIES_MISSED_OPPORTUNITY_BY_REGION_DATA,CORPORATE_OPPORTUNITIES_UNAPP_PRODUCT_DATA,
    CORPORATE_FAVORABLE_VENDOR_FEEDBACK,CORPORATE_OUT_VENDOR_FEEDBACK,CORPORATE_IN_VENDOR_FEEDBACK,
    CORPORATE_LPG_VENDOR_FEEDBACK,CORPORATE_BUYSELL_REP_VENDOR_FEEDBACK,CORPORATE_OVERVIEW_VOLUME_CARDS_DATA,
    CORPORATE_OVERVIEW_MP_INVOICES,CORPORATE_OVERVIEW_VP_INVOICES,
    CATEGORY_PRODUCTS_DETAILS,CORPORATE_OPPORTUNITY_MONTHS_FILTER,
    CORPORATE_CONVERSION_MONTHS_FILTER,TAB_TRACKING,VENDOR_GET_LPG_NAMES_MEMBER,
    CORPORATE_COMPLIANCE_MEMBER,CORPORATE_COMPLIANCE_VENDOR,CORPORATE_COMPLIANCE_YEAR_FILTER,VENDOR_DASHBOARD_GET_INDIVIDUAL_GROWTH_REBATE,MEMBER_VENDOR_NAMES1
} from '../constants';


// export const ROOT_URL = process.env.PUBLIC_URL === '/imarkdemo' ? 
//     "https://omni.tredence.com/imark-demo" : process.env.PUBLIC_URL === '/imarkgroup' ? 
//         "https://imark-plumbing.tredence.com/imark-dashboard" : "https://omni.tredence.com/imark-dashboard";

export const ROOT_URL = process.env.PUBLIC_URL === '/imarkdemo' ? 
    "https://omni.tredence.com/imark-demo" : process.env.PUBLIC_URL === '/imarkgroup' ? 
    // "https://imark-plumbing.tredence.com/imark-demo" : process.env.PUBLIC_URL === '/imarkgroup' ?
        "https://imark-plumbing.tredence.com/imark-dashboard" :process.env.PUBLIC_URL === '/imarktest' ?
        // "http://10.10.105.9/imark-dashboard" :process.env.PUBLIC_URL === '/imarktest' ?
        "https://omni.tredence.com/imark-dashboard-test" :process.env.PUBLIC_URL === '/imarkmigration' ?
        "https://omni.tredence.com/imark-dashboard-migration" :process.env.PUBLIC_URL === '/equity-test' ?
        "https://imark-plumbing.tredence.com/equity-api" : process.env.PUBLIC_URL === '/equity' ?
        "https://imark-plumbing.tredence.com/equity-api" : process.env.PUBLIC_URL === '' ?
        "http://localhost:8080":"https://imark-plumbing.tredence.com/imark-dashboard"
        // : "http://10.10.105.9/imark-dashboard";
        
export const UPDATE_DATE_APPLICATION = "06/17/2020";
export const UPDATE_DATE_DATA = "07/07/2020";

let token = localStorage.getItem('imark-token');

let token1=sessionStorage.getItem('imark-token')
console.debug("Setting Authentication Token", token);

let imarkToken1= "Bearer " + token1;

axios.defaults.headers.common['Authorization'] = "Bearer " + token;
// Add a response interceptor

axios.interceptors.response.use(function (response) {

    if (response.data.success === false && (response.data.message.name === "TokenExpiredError" || response.data.message.name === "JsonWebTokenError")) {
        console.log('response in interceptor ', response);
        localStorage.clear();
        window.location = "/";
    }
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export const saveMemberId = (selections) => async dispatch => {
    console.log('saving member ID ', selections);

    let request = dispatch({ type: SAVE_MEMBER_ID, payload: selections });
    return request;
}


export const saveVendorId = (selections) => async dispatch => {
    console.log('saving vendor ID ', selections);
    let request = dispatch({ type: SAVE_VENDOR_ID, payload: selections });
    return request;
}
export const tabTrackingValue = {
    "1" : "SSO" ,
    "2" : "Standard Login",
    "3" : "Member Overview",
    "4" : "Member Virified Data",
    "5" : "Invoice Details",
    "6" : "PO Details",
    "7" : "Member Conversion Opportunity",
    "8" : "FBI Rebate",
    "9" : "Vendor Overview",
    "10" : "Vendor Conversion Opportunity",
    "11" : "Corporate Verified Data",
    "12" : "Corporate Vendor Data",
    "13" : "Corporate Opportunity",
    "14" : "Manage Feedback",
    "15" : "Corporate Conversion Opportunity",
    "16" : "Compliance"
    
};
// TAB Tracking 
export const tabTracking = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/track?`+ selections).then((res) => {
        dispatch({ type: TAB_TRACKING, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

// export const switchDashboard = (selections) => async dispatch => {
//     let request = axios.get(`${ROOT_URL}/switch-dashboard`).then((res) => {
//         dispatch({ type: SWITCH_DASHBOARD, payload: res }); return Promise.resolve(res);
//     }).catch((error) => {
//         console.log('error', error);
//         return Promise.reject(error);
//     })
//     return request;
// }


// TAB Tracking api end
//Forgot Password
export const forgotPassword = (selections) => async dispatch => {
    let request = axios.post(`${ROOT_URL}/forgot`, selections).then((res) => {
        dispatch({ type: FORGOT_PASSWORD, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

//Verify Token
export const verifyToken = (selections) => async dispatch => {
    let request = axios.post(`${ROOT_URL}/verifyToken`, selections).then((res) => {
        dispatch({ type: VERIFY_TOKEN, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

//Update Password
export const updatePassword = (selections) => async dispatch => {
    let request = axios.post(`${ROOT_URL}/recover-password`, selections).then((res) => {
        dispatch({ type: UPDATE_PASSWORD, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

//
export const changePassword = (selections) => async dispatch => {
    let request = axios.post(`${ROOT_URL}/reset-password`, selections).then((res) => {
        dispatch({ type: CHANGE_PASSWORD, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


// common for all terminated Vandor Id
export const getTerminatedVPNames = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor-directory?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_TERMINATED_VP_NAMES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getTerminatedVPNamesForMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor-directory?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_TERMINATED_VP_NAMES_MEMBER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getTerminatedVPNamesForCorporate = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor-directory?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_TERMINATED_VP_NAMES_CORPORATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

//overview tab
export const getCorporateOverviewOverallVolumeCards = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/rebate-overview-verified?`+ selections).then((res) => {
         dispatch({ type: CORPORATE_OVERVIEW_OVERALL_SALES_AND_REBATE_DATA, payload: res.data });
   
    return Promise.resolve(res.data);
}).catch((error)=>{
        console.log('error', error);
        return Promise.reject(error);
})

return request;
}

export const regionCodeNameMapping = {
    'sc': 'South Central',
    'nw': 'North West',
    'sw': 'South West',
    'se': 'South East',
    'ne': 'North East',
    'mw': 'Mid West'
};

export const getStateRegions = () => async dispatch => {
    let data = {
       or:'nw',
        id:'nw',
        wy:'nw',
        mt:'nw',
        wa:'nw',

        nm:'sw',
        ak:'sw',
        az:'sw',
        co:'sw',
        ut:'sw',
        nv:'sw',
        ca:'sw',

        la:'sc',
        ar:'sc',
        ks:'sc',
        ok:'sc',
        tx:'sc',
        hi:'sc',

        'va':'se',
        'nc':'se',
        'sc':'se',
        'tn':'se',
        'ms':'se',
        'al':'se',
        'ga':'se',
        'fl':'se',

        md:'ne',
        de:'ne',
        nj:'ne',
        pa:'ne',
        ny:'ne',
        ma:'ne',
        ct:'ne',
        nh:'ne',
        vt:'ne',
        me:'ne',
        ri:'ne',

        nd:'mw',
        mn:'mw',
        sd:'mw',
        ne:'mw',
        ia:'mw',
        mo:'mw',
        ky:'mw',
        wv:'mw',
        oh:'mw',
        mi:'mw',
        il:'mw',
        wi:'mw',
        in:'mw',
 }
    dispatch({ type: STATE_REGIONS, payload: data })
}
export const getStateToStateMapping = () => async dispatch => {
    let data = {
        'North West':'nw',
        Oregon: 'or',
        Idaho: 'id',
        Wyoming: 'wy',
        Montana: 'mt',
        Washington: 'wa',

        'South West':'sw',
        'New Mexico': 'nm',
        Alaska: 'ak',
        Arizona: 'az',
        Colorado: 'co',
        Utah: 'ut',
        Nevada: 'nv',
        California: 'ca',

        'South Central':'sc',
        Louisiana: 'la',
        Arkansas: 'ar',
        Kansas: 'ks',
        Oklahoma: 'ok',
        Texas: 'tx',
        Hawaii: 'hi',

        'South East':'se',
         Virginia: 'va',
        'North Carolina': 'nc',
        'South Carolina': 'sc',
        Tennessee: 'tn',
        Mississippi: 'ms',
        Alabama: 'al',
        Georgia: 'ga',
        Florida: 'fl',

        'North East':'ne',
        'Maryland': 'md',
        Delaware: 'de',
        'New Jersey': 'nj',
        Pennsylvania: 'pa',
        'New York': 'ny',
        Massachusetts: 'ma',
        Connecticut: 'ct',
        'New Hampshire': 'nh',
        Vermont: 'vt',
        Maine: 'me',
        'Rhode Island': 'ri',

        'Mid West':'mw',
        'North Dakota': 'nd',
        Minnesota: 'mn',
        'South Dakota': 'sd',
        'Nebraska': 'ne',
        Iowa: "ia",
        Missouri: 'mo',
        Kentucky: 'ky',
        'West Virginia': 'wv',
        Ohio: 'oh',
        Michigan: 'mi',
        Illinois: 'il',
        Wisconsin: 'wi',
        Indiana: 'in',
    }
    dispatch({ type: STATE_TO_STATE_MAPPING, payload: data })
}

export const getCorporateOverviewVPPerformance = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor-performance?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_VENDOR_PARTNER_PERFORMANCE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getCorporateOverviewMemberPerformance = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member-performance?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_MEMBER_PERFORMANCE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getCorporateBaseRebatesOverview = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/verified-data-overview?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_BASE_REBATES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getCorporateOverviewVPInvoices = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/invoice-per-po-by-vendor?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_VP_INVOICES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getCorporateOverviewMPInvoices = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/invoice-per-po-by-member?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_MP_INVOICES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getCorporateOverviewGrowthRebate = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/growth-rebate-verified?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_GROWTH_REBATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getCorporateVendorOverviewOverallVolumeCards= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-vendor-rebate-overview?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OVERVIEW_VOLUME_CARDS_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/months-filter?`+ selections).then((res) => {
        dispatch({ type: MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getCorporateConversionMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-months-filter?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_CONVERSION_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getCorporateOpportunityMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/opportunity-months-filter?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OPPORTUNITY_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getMemberMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member-months-filter?`+ selections).then((res) => {
        dispatch({ type: MEMBER_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getMemberConversionMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-months-filter?`+ selections).then((res) => {
        dispatch({ type: MEMBER_CONVERSION_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getMemberVerifiedMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/membr-verified-months-filter?`+ selections).then((res) => {
        dispatch({ type: MEMBER_VERIFIED_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getVendorMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor-months-filter?`+ selections).then((res) => {
        dispatch({ type: VENDOR_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getVendorConverisonMonthsFilter= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor/conversion/filter-values?`+ selections).then((res) => {
        dispatch({ type: VENDOR_CONVERSION_MONTHS_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}



//corporate rebate data tab
export const getCorporateOverviewGrowthRebateVendortab = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/growth-rebate-vendor?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_VENDORDATA_GROWTH_REBATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}



///////////////



export const getPurchasedOrdersMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/purchase-order/list?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_PURCHASED_ORDERS, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


export const getbHverifiedVendorPartnerPurchases = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/verified-inside-purchases?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_BH_VERIFIED_VENDOR_PARTNER_PURCHASES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getInvoiceData = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/invoice/list?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_INVOICE_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getMemberVendorNames = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor/conversion/terminated-list?`+ selections).then((res) => {
        dispatch({ type: MEMBER_VENDOR_NAMES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getConversionOppVendorList = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-vendor-list`).then((res) => {
        dispatch({ type: MEMBER_VENDOR_NAMES1, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getTerminatedVPOpportunitiesDetails = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-po-details?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_TERMINATED_VP_OPPORTUNITIES_DETAILS, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getTerminatedVPOpportunities = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-overview?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_TERMINATED_VP_OPPORTUNITIES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


//Apis remaining

export const getMemberBranch = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/filter-member-ids?`+ selections).then((res) => {
        dispatch({ type: MEMBER_BRANCH, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

}

export const getCardsDataForMemberDataTab = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member/overview/rebate-overview?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_CARDS_DATA_FOR_MEMBER_DATA_TAB, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

}
export const getmemberQualification = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/membership-qualification?`+ selections).then((res) => {
        dispatch({ type: MEMBER_QUALIFICATION, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

}
export const getmemberQualification2021 = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/membership-qualification-status`+ selections).then((res) => {
        dispatch({ type: MEMBER_QUALIFICATION_STATUS, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

}
// export const getmemberPurchases = (selections) => async dispatch => {
//     let request = axios.get(`${ROOT_URL}/member-purchases?`+ selections).then((res) => {
//         dispatch({ type: MEMBER_QUALIFICATION, payload: res.data }); return Promise.resolve(res.data);
//     }).catch((error) => {
//         console.log('error', error);
//         return Promise.reject(error);
//     })
//     return request;

// }
export const getmemberPurchases = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member-purchases`+ selections).then((res) => {
        dispatch({ type: MEMBER_QUALIFICATION_PURCHASES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

}
export const getMemberInvoicesBranchData = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/branches?`+ selections).then((res) => {
        dispatch({ type: MEMBER_INVOICES_BRANCH, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

}

export const getMemberPurchaseWithinImarkValue = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member/overview/purchases?`+ selections).then((res) => {
        dispatch({ type: MEMBER_PURCHASE_WITHIN_IMARK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request; 
}

export const getMemberPurchaseOutsideImarkValue = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member/outside-purchases-by-vendor?`+ selections).then((res) => {
        dispatch({ type: MEMBER_PURCHASE_OUTSIDE_IMARK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getMemberOutsidePurchaseByCategory = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member/outside-purchases-by-category?`+ selections).then((res) => {
        dispatch({ type: MEMBER_OUTSIDE_PURCHASE_BY_CATEGORY, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request; 
}

export const getLPGNamesForMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/lpg-vendors?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_LPG_NAMES_MEMBER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


export const saveOutVendorFeedback = 
(selections, callback) => async () => {
    axios.post(`${ROOT_URL}/save-out-vendor-feedback`,selections).
    then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const saveProductFeedback = 
(selections, callback) => async () => {
   await axios.post(`${ROOT_URL}/save-product-feedback`,selections).
    then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const getVendorInfo = (id,selections, callback) => async () => {
    axios.get(`${ROOT_URL}/vendor/${id}/info`, selections).then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    //getMemberDataUnapprovedSupplierPurhcaseByCategoryPopUp MEMBER_FAVORABLE_SUPPLIER_FEEDBACK
}

export const getProductCategory = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/product-category`, selections).then((res) => {
        dispatch({ type: MEMBER_PRODUCT_CATEGPRY, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
    
    
}

export const getProductCategorycorporate = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/product-category`, selections).then((res) => {
        dispatch({ type: CORPORATE_PRODUCT_CATEGORY, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

    
}

export const getProductCategoryVendor = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/product-category`, selections).then((res) => {
        dispatch({ type: VENDOR_PRODUCT_CATEGORY, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

    
}


export const getVendorFullInfo = (id,selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor/${id}/info`, selections).then((res) => {
        dispatch({ type: VENDOR_FULL_INFO, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

    
}
export const getOutsidePurchaseProductCategory = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member/outside-purchases-by-category/product-list?`+ selections).then((res) => {
        dispatch({ type: VENDOR_OUTSIDE_PURCHASE_PRODUCT_CATEGORY_LIST, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;

    
}

export const getCardsDataForIMARKVerifiedDataTab = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/verified-overview-boxes?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_CARDS_DATA_FOR_IMARKVERIFIED_DATA_TAB, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getVerifiedRebateTrendsGraph = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/verified-rebate-trends-graph?`+ selections).then((res) => {
        dispatch({ type: MEMBER_GET_VERIFIED_REBATE_TRENDS_GRAPH, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}




///////////////Vendor


export const getFbiRebateMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/fbi-programs?`+ selections).then((res) => {
        dispatch({ type: MEMBER_FBI_REBATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getFbiRebateEligibleCheck = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/fbi-vendors?`+ selections).then((res) => {
        dispatch({ type: MEMBER_FBI_ELIGIBLE_CHECK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getVendorTop10MembersData = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor/conversion/top-members?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_TOP_10_MEMBERS_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getVendorOpportunityByMemberData = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor/conversion/members?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_OPPORTUNITY_BY_MEMBER, payload: res.data });
        return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getVendortvOpportunityByCategoryData = (selections) => async dispatch => {
    let request = await axios.get(`${ROOT_URL}/vendor/conversion/categories?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_TVOPPORTUNITY_BY_CATEGORY, payload: res.data });
        return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getProductDetail = (selections) => async dispatch => {
    let request = await axios.get(`${ROOT_URL}/conversion-opportunity-products?`+ selections).then((res) => {
        dispatch({ type: CATEGORY_PRODUCTS_DETAILS, payload: res.data });
        return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getVendorOpportunityByCategoryData = (selections) => async dispatch => {
    let request = await axios.get(`${ROOT_URL}/sales-opportunity-product-group?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_OPPORTUNITY_BY_CATEGORY, payload: res.data });
        return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getVendorTop10CategoriesData = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor/conversion/top-categories?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_TOP_10_CATEGORIES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getVendorSalesRebatCardData = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/vendor-overview-boxes?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_SALES_CARD_DATA, payload: res.data });
        return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getDashboardRebatesOverview = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/sales-rebate-overview?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_REBATES_OVERVIEW, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getDashboardGrowthRebate = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/growth-rebate-vendor?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_GROUP_GROWTH_REBATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getProductListVendorDashboard = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/sales-opportunity-product-list?`+ selections).then((res) => {
        dispatch({ type: VENDOR_PRODUCT_LIST, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
    
}

export const getDashboardSalesOpportunityGraph = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/opportunity-by-vendor?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_GRAPH, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

/* Member data comparison graph on 02/06/2021*/
export const getMemberPurchasesDataa = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member-purchase-comparison?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_MEMBER_PURCHASES_GRAPH, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


export const getMemberList = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member-purchase-comparison/members?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_MEMBER_LIST, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
/*ended */ 

export const getDashboardSalesOpportunityByBusiness = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/sales-opportunity-business?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_BUSINESS, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getDashboardSalesOpportunityByMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/sales-opportunity-member?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_MEMBER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getDashboardSalesOpportunityByRegion = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/sales-opportunity-region?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_REGION, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}



export const getDashboardIndividualGrowthRebate = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/individual-growth-rebate?`+ selections).then((res) => {
        dispatch({ type: VENDOR_DASHBOARD_GET_INDIVIDUAL_GROWTH_REBATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


// export const conversionEligibilityCheck = (selections) => async dispatch => {
//     let request = axios.get(`${ROOT_URL}/vendor-conversion-opportunity?`+ selections).then((res) => {
//         dispatch({ type: VENDOR_CONEVRSION_TAB_ELIGIBILITY_CHECK, payload: res.data }); return Promise.resolve(res.data);
//     }).catch((error) => {
//         console.log('error', error);
//         return Promise.reject(error);
//     })
//     return request;
// }


/////////////Corporate apis
//TVPO APIs
export const getTerminatedVpOppVolumeOppByMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-member?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_TVPO_VOLUME_OPP_BY_MEMBER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getTerminatedVpOppConversionOppPoDetails = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-po-details?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_TVPO_CONVERSION_OPP_PO_DETAILS_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getTerminatedVpOppConversionOpp = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-overview?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_TVPO_CONVERSION_OPPORTUNITY_DATA, payload: res.data }); 
        return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getTerminatedVpOppTopTenMembers = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/top-ten-conversion-opportunity-member?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_TVPO_TOP_10_MEMBERS_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getTerminatedVpOppTopTenProductGroups = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/top-ten-conversion-opportunity-product-group?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_TVPO_TOP_10_PRODUCT_GROUPS_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getTerminatedVpOppVolumeOppByProductGroup = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-product-group?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_TVPO_VOLUME_OPP_BY_PRODUCT_GROUP_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
//Opportunity tab
export const getOpportunitiesCards = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-opportunity-overview?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OPPORTUNITIES_CARDS_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getSalesRebateOpportunitiesTrend = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-opportunity-trend?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_SALES_REBATE_OPPORTUNITIES_TREND, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getOpportunitiesByRegion = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-opportunity-region?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OPPORTUNITIES_MISSED_OPPORTUNITY_BY_REGION_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getOpportunitiesUnapprovedSupplierVolumeByMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-opportunity-member?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OPPORTUNITIES_UNAPP_SUPP_VOLUME_BY_MEMBER_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getOpportunitiesVendorPartnerVolume = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-opportunity-out-vendors?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OPPORTUNITIES_VENDOR_PARTNER_VOLUME_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getOpportunitiesUnapprovedProductGroup = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/corporate-opportunity-product-group?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_OPPORTUNITIES_UNAPP_PRODUCT_DATA, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getFbiRebate = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/fbi-programs?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_FBI_REBATE, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}


export const getTerminatedVpOppVendorNames = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/conversion-opportunity-vendor-list`).then((res) => {
        dispatch({ type: CORPORT_TVPO_TVPO_NAMES, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
//feedback APIs
export const getFeedbackUnapprovedSupplierMapping = () => async dispatch => {
    let request = axios.post(`${ROOT_URL}/corporate/feedback/getFeedbackUnapprovedSupplierMapping`).then((res) => {
        dispatch({ type: CORPORATE_FEEDBACK_UNAPPROVED_SUPPLIER_MAPPING, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getFeedbackWrongCategory = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/wrong-category-feedback`).then((res) => {
        dispatch({ type: CORPORATE_FEEDBACK_WRONG_CATEGORY, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getFeedbackProductsNotSold = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/product-not-sold-feedback`).then((res) => {
        dispatch({ type: CORPORATE_FEEDBACK_PRODUCTS_NOT_SOLD, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getFavourableVendorFeedback = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/favorable-vendor-feedback`).then((res) => {
        dispatch({ type: CORPORATE_FAVORABLE_VENDOR_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getInVendorFeedback = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/in-vendor-feedback`).then((res) => {
        dispatch({ type: CORPORATE_IN_VENDOR_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getLpgVendorFeedback = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/lpg-vendor-feedback`).then((res) => {
        dispatch({ type: CORPORATE_LPG_VENDOR_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getBuySellRepVendorFeedback = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/buysell-rep-vendor-feedback`).then((res) => {
        dispatch({ type: CORPORATE_BUYSELL_REP_VENDOR_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getOutVendorFeedback = () => async dispatch => {
    let request = axios.get(`${ROOT_URL}/out-vendor-feedback`).then((res) => {
        dispatch({ type: CORPORATE_OUT_VENDOR_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const getFeedbackFavorableSupplierFeedback = () => async dispatch => {
    let request = axios.post(`${ROOT_URL}/corporate/feedback/getFeedbackFavorableSupplierFeedback`).then((res) => {
        dispatch({ type: CORPORATE_FEEDBACK_FAVORABLE_SUPPLIER_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
//UPDATE FEEDBACK
export const getMemberDataUnapprovedSupplierPurhcaseByCategoryPopUp = (selections) => async dispatch => {
    let request = axios.post(`${ROOT_URL}/member/outside-purchases-by-vendor/feedback/save`, selections).then((res) => {
        dispatch({ type: MEMBER_FAVORABLE_SUPPLIER_FEEDBACK, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}
export const updateFeedbackWrongCategory = 
(id,feedbackStatus, callback) => async () => {
    axios.post(`${ROOT_URL}/wrong-category-feedback/${id}`,
    {   
        request : feedbackStatus,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const updateFeedbackProductNotSold = 
(id,feedbackStatus, callback) => async () => {
    axios.post(`${ROOT_URL}/product-not-sold-feedback/${id}`,
    {   
        request : feedbackStatus,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const updateFeedbackFavourableVendor = 
(id,feedbackStatus, callback) => async () => {
    axios.post(`${ROOT_URL}/favorable-vendor-feedback/${id}`,
    {   
        request : feedbackStatus,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const updateFeedbackforInOutLpgBuySellVendor = 
(id,feedbackStatus, callback) => async () => {
    axios.post(`${ROOT_URL}/vendor-feedback/${id}`,
    {   
        request : feedbackStatus,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
// Feedback update api as whole 
export const updateAllFeedbackWrongCategory = 
(id,selections, callback) => async () => {
    axios.post(`${ROOT_URL}/wrong-category-feedback-update`,
    {   
        request :selections ,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const updateAllFeedbackProductNotSold = 
(id,selections, callback) => async () => {
    axios.post(`${ROOT_URL}/product-not-sold-feedback-update`,
    {   
        request : selections,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const updateAllFeedbackFavourableVendor = 
(id,selections, callback) => async () => {
    axios.post(`${ROOT_URL}/favorable-vendor-feedback-update`,
    {   
        request : selections,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}
export const updateAllFeedbackforInOutLpgBuySellVendor = 
(id,selections, callback) => async () => {
    axios.post(`${ROOT_URL}/vendor-feedback-update`,
    {   
        request : selections,
        }
    )
    .then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
    
}

export const insertFeedbackUnapprovedSupplierFeedback = (selections, callback) => async () => {
    axios.post(`${ROOT_URL}/corporate/feedback/insertFeedbackUnapprovedSupplierFeedback`, selections).then((res) => {
        callback(res);
    }).catch(err => {
        console.log(err);
    })
}

/////////////Authentication APIs
export const login = (selections, callback) => async () => {
    axios.post(`${ROOT_URL}/authenticate`, selections, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'mode': 'cors'
    },}).then((res) => {
        // if (res) {
            console.log('in action ', res);
            callback(res);
        // }
        // else {
        //     console.log('Failed');
        // }

    }).catch(err => {
        console.log('error ', err);
        callback(err);
    })
}

export const tokenLogin = (ssoToken) => async () => {
    let ssoParameter = new URLSearchParams();
    ssoParameter.set('token', ssoToken)
    return axios.get(`${ROOT_URL}/authenticate?` + ssoParameter.toString());
}


//CORPORATE_TVPO_CONVERSION_OPP_PO_DETAILS_DATA

export const handleExpiredToken = () => async dispatch => {
    dispatch({ type: TOKEN_ERROR, payload: "token expired" });
}

// Corporate Compliance tab apis

export const getComplianceMember = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/compliance-member?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_COMPLIANCE_MEMBER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getComplianceVendor = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/compliance-vendor?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_COMPLIANCE_VENDOR, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const getComplianceYearFilter = (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/compliance-year-filter?`+ selections).then((res) => {
        dispatch({ type: CORPORATE_COMPLIANCE_YEAR_FILTER, payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

// vendor date fetch
export const getMemberVendorDate= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/member-purchase-comparison/members-update-date?`+ selections).then((res) => {
        dispatch({ type: VENDOR_GET_DATE ,payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

//member purchseorder api
export const getPurchaseOrderExcel= (selections) => async dispatch => {
    let request = axios.get(`${ROOT_URL}/purchase-order/download?`+ selections).then((res) => {
        dispatch({ type: MEMBER_PURCHASE_ORDER_EXCEL ,payload: res.data }); return Promise.resolve(res.data);
    }).catch((error) => {
        console.log('error', error);
        return Promise.reject(error);
    })
    return request;
}

export const acceptTerms = (selections) => async (dispatch) => {
    let request = axios.get(`${ROOT_URL}/acceptTerms?userId=` + selections.userId,
    {
        // You probably don't need to do this! withCredentials: true,
        // headers: {
        //   Authorization:imarkToken1
        // },

      })
        .then((res) => {
            return Promise.resolve(res.data);

        });
        console.log('checking token', imarkToken1)
        return request;
    }
export const disagreeTerms = (selections, callback) => async (dispatch) => {
    let request = axios.get(`${ROOT_URL}/disagreeTerms?userId=` + selections.userId,
    {
        // You probably don't need to do this! withCredentials: true,
        // headers: {
        //   Authorization:imarkToken1
        // },

      })
        .then((res) => {
            return Promise.resolve(res.data);

        });

        return request;
};

